/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';

export interface PopupClientControllerFindAllV1$Params {
}

export function popupClientControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PopupClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
  const rb = new RequestBuilder(rootUrl, popupClientControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PopupDto>>;
    })
  );
}

popupClientControllerFindAllV1.PATH = '/api/v1/popups/client';
